export default "__VITE_ASSET__7e937f90__"